export enum ReturnOverviewTabType {
  successEpoch = "successEpoch",
  failureEpoch = "failureEpoch",
}
